import { SubscriberProperties, VisioService } from '@agent/core/channel-digit/visio/visio.service';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

import { UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'cng-visio-toggle-actions',
  templateUrl: 'visio-toggle-actions.component.html',
  styleUrls: ['./visio-toggle-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisioToggleActionsComponent implements OnInit, OnChanges {
  @Input() stream: OT.Stream;

  hasVideo$ = new BehaviorSubject<boolean>(false);
  hasAudio$ = new BehaviorSubject<boolean>(false);
  hasScreen$ = this.visioService.screenSharingInProcess$.pipe(
    map(stream => !!stream && stream.connection.connectionId === this.stream.connection.connectionId)
  );
  subscriberStreamList$: Observable<OT.Stream[] | undefined> = this.visioService.subscriberStreamList$;

  constructor(private readonly visioService: VisioService) {
    this.visioService.subscriberChange$.pipe(untilDestroyed(this)).subscribe(event => {
      if (event.stream.connection.connectionId === this.stream.connection.connectionId) {
        switch (event.changedProperty) {
          case SubscriberProperties.hasAudio:
            this.hasAudio$.next(event.newValue);
            break;
          case SubscriberProperties.hasVideo:
            this.hasVideo$.next(event.newValue);
            break;
          default:
            break;
        }
      }
    });
  }

  ngOnInit() {
    if (!this.stream) {
      return;
    }
    this.hasAudio$.next(this.stream.hasAudio);
    this.hasVideo$.next(this.stream.hasVideo);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { ['stream']: entries } = changes;
    if (!(entries && entries.currentValue && entries.previousValue !== entries.currentValue)) {
      return;
    }

    this.hasAudio$.next(this.stream.hasAudio);
    this.hasVideo$.next(this.stream.hasVideo);
  }

  getState(active: boolean): string {
    return active ? 'ENABLED' : 'DISABLED';
  }

  extractUsername(stringEntry): string {
    if (!stringEntry) {
      return '';
    }

    let data = JSON.parse(stringEntry.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
    let username = data.username;
    return username;
  }

  toggleAudio() {
    this.visioService.sendAction('TOGGLE_SOUND', this.stream.connection.connectionId, this.extractUsername(this.stream.connection.data));
  }

  toggleVideo() {
    this.visioService.sendAction(
      'TOGGLE_VIDEO_CAMERA',
      this.stream.connection.connectionId,
      this.extractUsername(this.stream.connection.data)
    );
  }

  toggleScreen() {
    this.visioService.sendAction(
      'TOGGLE_VIDEO_SCREEN',
      this.stream.connection.connectionId,
      this.extractUsername(this.stream.connection.data)
    );
  }
}
